import { trpc } from '@/shared/api';

/** 주문별 입금 안내 — 반환 타입은 라우터 계약에서 추론한다. */
export const useBankTransferQuery = (
  orderId: string,
  options: { readonly enabled?: boolean } = {},
) =>
  trpc.payments.getBankTransfer.useQuery(
    { orderId },
    { enabled: options.enabled ?? true, retry: false },
  );
